import { Outlet } from "react-router-dom";
import Container from "../utils/Container";

import LayoutHeader from "./LayoutHeader";
import Footer from "./Footer";
import { ToastContainer } from "react-toastify";

const LayoutMain = () => {
  // logik
  return (
    <main className="main">
      <ToastContainer />
      <LayoutHeader />

      <Container style={{ marginTop: "0" }}>
        {/* Platzhalter für die Seite, die der Router lädt */}
        <Outlet />
      </Container>
      <Footer />
    </main>
  );
};

export default LayoutMain;
